import {combineReducers} from "redux";
import {BoardStyleReducer} from "./BoardStyle/BoardStyle";
import {BoardReducer} from "./Board/Board";
import {UserReducer} from "./User/User";
import {LabelsReducer} from "./Labels/Labels";
import {DescriptionReducer} from "./Description/Description";
import {BoardCreateReducer} from "./BoardCreate/BoardCreateReducer";

export const rootReducer = combineReducers({
    user: UserReducer,
    boardStyle: BoardStyleReducer,
    boards: BoardReducer,
    labels: LabelsReducer,
    description: DescriptionReducer,
    boardCreate: BoardCreateReducer
})